import { Component, Inject, Input, Output, OnDestroy, EventEmitter } from '@angular/core';

import { projectActions } from '@src/store/reducers/projectReducer';
import { Store } from '@src/store';
import { consts } from '@src/constants/consts';

import _ from 'lodash';
import $ from 'jquery';

@Component({
    selector: 'packages-versions',
    template: require('./packages-versions.component.html'),
    styles: [require('./packages-versions.component.scss')]
})
export class PackagesVersionsComponent implements OnDestroy {
    @Input() public projectWithMetaData: any;

    @Output() public onClickPackage = new EventEmitter<any>();
    @Output() public onNewPackage = new EventEmitter();
    @Output() public resetPackagesData = new EventEmitter<any>();

    public isCollapsedUp = true;
    public isCollapsedDown = true;
    public selectedItem: any;
    public packagesAdhoc: any;
    public packagesNormal: any;
    public checkBoxItemsFilters = [
        { name: 'Regular', selected: true, disabled: true, type: 0 },
        { name: 'Ad-hoc', selected: true, disabled: true, type: 3 },
        { name: 'Disabled', type: 1, selected: false, disabled: false },
        { name: 'Rollback', selected: false, disabled: false, type: 2 },
        { name: 'Obsolete', selected: false, disabled: false, type: 4 }
    ];

    private projectId: any;
    private isDisableMode = false;
    private isRollbackMode = false;
    private isAdhocMode = false;
    private isObsoleteMode = false;
    private userId: any;
    private packages: any[];
    private searchFilter: any;
    private unsubscribe: any;
    private packagesAdhocInitialSearchCopy: any;

    constructor(
        private store: Store,
        @Inject('$stateParams') $stateParams: any,
        @Inject('$scope') private $scope: any,
        @Inject('packagesLocalHistoryService') private packagesLocalHistoryService: any,
        @Inject('$state') $state: any) {
        this.projectId = $stateParams.id;
        this.userId = $state.$current.locals.globals.userDetails.data.id;
        // set default filter value
        this.onPackageFilterChange([{ name: 'Regular', selected: true, disabled: true, type: 0 },
            { name: 'Ad-hoc', selected: true, disabled: true, type: 3 }]);

        $scope.$on(consts.emitedEventsTypes.receivedPackagesData, (__: any, data: any) => {
            if (!$stateParams.packageName) {
                if (data.needDataRefresh) {
                    this.initialDataFilterState();
                }
                const lastVisitedPackageId = this.getLastSelectedPackage();
                const lastVisitedPackage = this.packages.find(pkg => pkg.id === lastVisitedPackageId);
                if (lastVisitedPackage) {
                    this.selectedItem = lastVisitedPackage;
                    this.onSearchKey(this.searchFilter);
                } else {
                    this.resetPackagesSelection();
                }
            } else {
                const packageToSelect = _.find(this.packages, (pkg: any) => pkg.name === $stateParams.packageName);
                const indexOfPackageToSelect = _.findIndex(this.packages, (pkg: any) => pkg.id === packageToSelect.id);
                if (packageToSelect.isAdhocPackage) {
                    const index = this.calculateIndexOfAdHocPackage(indexOfPackageToSelect);
                    this.onAdhocPackageClick(packageToSelect, index);
                } else {
                    this.onNormalPackageClick(packageToSelect, indexOfPackageToSelect);
                }
            }
        });
        this.unsubscribe = store.subscribe(() => {
            const packages = this.store.getState().packageManager.packages;
            if (packages && packages.length > 0 && (this.isPackagesChanged(packages) || this.isTagChange(packages))) {
                this.initialDataFilterState();
            }
        });
        $scope.$watch(() => this.packages, (newVal: any, oldVal: any) => {
            if (newVal && oldVal && newVal.length !== oldVal.length || this.isFirstPackageCreation(newVal, oldVal)) {
                this.resetPackagesSelection();
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }

    private isPackagesChanged(packages): boolean {
        return !this.packages || this.packages.length !== packages.length;
    }

    private isTagChange(packages): boolean {
        if (!packages || !this.packages){
            return false;
        }
        const newPackages = packages.map(item => item.Tags.length).reduce((sum, curr) => (sum + curr));
        const oldPackages = this.packages.map(item => item.Tags.length).reduce((sum, curr) => (sum + curr));
        return newPackages !== oldPackages;
    }

    private getLastSelectedPackage() {
        return this.packagesLocalHistoryService.getLastFocusedPackage(this.userId, this.projectId);
    }

    public setLastSelectedPackage(selectedPackage: any) {
        if (!selectedPackage.isTemporary) {
            this.packagesLocalHistoryService.setLastFocusedPackage(this.userId, this.projectId, selectedPackage.id);
        }
    }

    private isFirstPackageCreation(newVal: any, oldVal: any) {
        return newVal && !oldVal && newVal.length === 1;
    }

    private findNewlyAddedPackage() {
        return { ..._.maxBy(this.packages, 'id') };
    }

    private resetPackagesSelection() {
        const newlyAddedPackage = this.findNewlyAddedPackage();
        this.selectedItem = newlyAddedPackage;
        this.packagesLocalHistoryService.setLastFocusedPackage(this.userId, this.projectId, newlyAddedPackage.id);
        this.onSearchKey(this.searchFilter);
    }

    private calculateIndexOfAdHocPackage(indexInAllPackages: any) {
        const indexOfFirstAdhocPackage = _.findIndex(this.packages, (pkg: any) => pkg.isAdhocPackage);
        return indexInAllPackages - indexOfFirstAdhocPackage;
    }

    public onSearchKey(filter: any) {
        let filteredNormalPackages: any;
        let selectedPackageIndex: any;
        if (filter) {
            this.searchFilter = filter;
            const compareName = (name: string) => name.toLowerCase().includes(filter.toLowerCase());
            filteredNormalPackages = this.packagesNormal.filter((x: any) => compareName(x.name));
            this.packagesAdhoc = this.packagesAdhocInitialSearchCopy.filter((x: any) => compareName(x.name));
        } else {
            delete this.searchFilter;
            this.packagesAdhoc = this.packagesAdhocInitialSearchCopy;
            filteredNormalPackages = this.packagesNormal;
        }

        if (this.selectedItem && (this.packagesAdhoc.length > 0 || filteredNormalPackages.length > 0)) {
            selectedPackageIndex = this.packagesAdhoc.findIndex((pkg: any) => pkg.id === this.selectedItem.id);
            if (selectedPackageIndex === -1) {
                selectedPackageIndex = filteredNormalPackages.findIndex((pkg: any) => pkg.id === this.selectedItem.id);
                if (selectedPackageIndex === -1) {
                    selectedPackageIndex = 0;
                }
            }

            if (!this.selectedItem.isAdhocPackage && filteredNormalPackages.length > 0
                || this.selectedItem.isAdhocPackage && this.packagesAdhoc.length === 0) {
                this.onNormalPackageClick(filteredNormalPackages[selectedPackageIndex], selectedPackageIndex);
            } else if (this.selectedItem.isAdhocPackage && this.packagesAdhoc.length > 0
                || !this.selectedItem.isAdhocPackage && filteredNormalPackages.length === 0) {
                this.onAdhocPackageClick(this.packagesAdhoc[selectedPackageIndex], selectedPackageIndex);
            }
        }
    }

    private parserFilterChanges() {
        const filterStatePackages = [];
        _.each(this.store.getState().packageManager.packages, (item: any) => {
            const filterDisabled = this.isDisableMode || item.isEnabled;
            const filterTemporary = this.isRollbackMode || !item.isTemporary;
            const filterAdhoc = this.isAdhocMode || !item.isAdhocPackage;
            const filterObsolete = this.isObsoleteMode || !item.Tags.some(i=>i.name=="Obsolete"&&i.tagTypeId==10000);
            const isPush = filterDisabled&&filterTemporary&&filterAdhoc&&filterObsolete;

            if (isPush) {
                filterStatePackages.push(item);
            }
        });
        return filterStatePackages;
    }

    private initialDataFilterState() {
        const filteredSelectionPackages = this.store.getState().project.filteredSelectionPackages;
        if (filteredSelectionPackages && filteredSelectionPackages[this.projectId]) {
            const filteredSelection = filteredSelectionPackages[this.projectId];
            filteredSelection.forEach((item: any) => {
                const foundItem = this.checkBoxItemsFilters.find(x => x.type === item.type);
                foundItem.selected = item.selected;
            });
        }
        _.each(this.checkBoxItemsFilters, (item: any) => { this.setFilterVariables(item); });
        const filterStatePackages = this.parserFilterChanges();
        this.packages = filterStatePackages.reverse();
        this.packagesAdhocInitialSearchCopy = filterStatePackages.filter(p => p.isAdhocPackage);
        this.packagesAdhoc = [...this.packagesAdhocInitialSearchCopy];
        this.packagesNormal = filterStatePackages.filter(p => !p.isAdhocPackage);
    }

    private setFilterVariables(item: any) {
        switch (item.type) {
        case 1:
            this.isDisableMode = item.selected;
            break;
        case 2:
            this.isRollbackMode = item.selected;
            break;
        case 3:
            this.isAdhocMode = item.selected;
            break;
        case 4:
            this.isObsoleteMode = item.selected;
            break;
        }
    }

    public onPackageFilterChange(data: any) {
        if (data) {
            // reset selected flags
            _.each(this.checkBoxItemsFilters, (item: any) => { item.selected = false; });
            this.isDisableMode = false;
            this.isRollbackMode = false;
            this.isAdhocMode = false;
            this.isObsoleteMode = false;
            _.each(data, (item: any) => {
                const cbItem = _.find(this.checkBoxItemsFilters, (x: any) => item.type === x.type);
                if (cbItem) {
                    cbItem.selected = true;
                    this.setFilterVariables(item);
                }
            });
            this.store.dispatch({
                type: projectActions.SET_FILTERED_SELECTION_PACKAGES,
                payload: { [this.projectId]: data }
            });
            const filterStatePackages = this.parserFilterChanges();
            this.packages = filterStatePackages.reverse();
            this.packagesAdhoc = filterStatePackages.filter(p => p.isAdhocPackage);
            this.packagesAdhocInitialSearchCopy = filterStatePackages.filter(p => p.isAdhocPackage);
            this.packagesNormal = filterStatePackages.filter(p => !p.isAdhocPackage);
            if (this.searchFilter) {
                this.onSearchKey(this.searchFilter);
            }
            this.doFirstClickOnPackage();
        }
    }

    private doFirstClickOnPackage() {
        const action = () => {
            if (this.packagesNormal && this.packagesNormal.length > 0) {
                this.onClickPackage.emit({ data: this.packagesNormal[0] });
                $('#package .dbm-list li:nth-child(1)').click(); // better use this for clicks :)
                this.resetAdhocPackageSelection();
            } else if (this.packagesAdhoc && this.packagesAdhoc.length > 0) {
                this.onClickPackage.emit({ data: this.packagesAdhoc[0] });
                $('#adhocpackage .dbm-list li:nth-child(1)').click(); // better use this for clicks :)
                this.resetNormalPackageSelection();
            }
        };
        setTimeout(() => action(), 50);
    }

    // switch selected from list of normal packages and reset the ad-hoc selection
    public onNormalPackageClick(selectedItem: any, indexInList: any) {
        this.selectedItem = selectedItem;
        this.onClickPackage.emit({ data: selectedItem });
        const action = () => {
            $('#package li.selected').removeClass('selected');
            this.resetNormalPackageSelection();
            $(`#package .dbm-list li:nth-child(${indexInList + 1})`).addClass('selected');
            this.resetAdhocPackageSelection();
            this.broadcastScrollResetEvent(false, indexInList);
        };
        setTimeout(() => action(), 50);
    }

    // switch selected from list of ad-hoc packages and reset the normal selection
    public onAdhocPackageClick(selectedItem: any, indexInList: any) {
        this.selectedItem = selectedItem;
        this.onClickPackage.emit({ data: selectedItem });
        const action = () => {
            this.resetAdhocPackageSelection();
            $(`#adhocpackage .dbm-list li:nth-child(${indexInList + 1})`).addClass('selected');
            this.resetNormalPackageSelection();
            this.broadcastScrollResetEvent(true, indexInList);
        };
        setTimeout(() => action(), 50);
    }

    private broadcastScrollResetEvent(isAdhoc: any, indexInList: any) {
        this.$scope.$broadcast(consts.emitedEventsTypes.RESET_PACKAGES_SCROLL, { isAdhoc, indexInList });
    }

    private resetAdhocPackageSelection() {
        $('#adhocpackage li.selected').removeClass('selected');
        if (this.packages.length === 1) {
            const selectedPackageListItem = $('#package li.selected');
            if (!selectedPackageListItem || selectedPackageListItem.length === 0) {
                $('#package .dbm-list li:nth-child(1)').addClass('selected');
            }
        }
    }

    private resetNormalPackageSelection() {
        $('#package li.selected').removeClass('selected');
        if (this.packages.length === 1) {
            const selectedPackageListItem = $('#adhocpackage li.selected');
            if (!selectedPackageListItem || selectedPackageListItem.length === 0) {
                $('#adhocpackage .dbm-list li:nth-child(1)').addClass('selected');
            }
        }
    }

    public disableFinishRender() {
        return true;
    }

    public refreshAll() {
        this.resetPackagesData.emit({ needDataRefresh: true });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-versions/packages-versions.component.ts